import React from 'react';

const Switch = ({ id, isOn = false, handleToggle, onText, offText, style }) => {
	return (
		<div className="Switch">
			<input
				className="react-switch-checkbox"
				onChange={handleToggle}
				id={id || 'react-switch-new'}
				type="checkbox"
				checked={isOn}
			/>
			<label
				style={{
					background: isOn && '#48CD60',
					width: onText || offText ? '60px' : '50px',
					...style
				}}
				className="react-switch-label"
				htmlFor={id || 'react-switch-new'}
			>
				<span className="react-switch-button" />
			</label>
			{isOn && onText && offText ? (
				<span className="on-off-text on">{onText}</span>
			) : (
				<span className="on-off-text off">{offText}</span>
			)}
		</div>
	);
};

export default Switch;
